module.exports = __webpack_public_path__ + "img/shopping-bag.69b38d30.svg";